import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, Text, View, Platform, TouchableOpacity } from 'react-native';
import { Input, Button, ApplePay, Line, Icon, Colors } from '../components';
import { StringUtils, ArrayUtils } from '../utils';
import AuthController from '../controllers/authController';
import { useNavigate } from 'react-router-dom';
import { TextInput } from 'react-native-web';

class SignUpPaymentInput_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cc_number: '',
      cc_exp: '',
      cc_cvc: '',
      cc_zipcode: '',
      display_cc_inputs: false,
      price: props.price,
      total_price: props.price,
      display_promo_input: false
    }

    this.validateForm = this.validateForm.bind(this);
    this.subscriptionSignUp = this.subscriptionSignUp.bind(this);
    this.getCCInfo = this.getCCInfo.bind(this);
    this.verifyCoupon = this.verifyCoupon.bind(this);
  }

  componentDidUpdate() {
    if(!this.state.price || this.state.price !== this.props.price) {
      this.setState({
        price: this.props.price,
        total_price: this.props.price
      })
    }
  }

  async verifyCoupon() {
    let coupon_code = this.state.coupon;
    let amount = this.state.price;
    let response = await AuthController.verifyCoupon({coupon_code, amount});

    console.log('coupon response', response)
    if(response.success) {
      this.setState({
        coupon_applied: true,
        coupon_error: null,
        trial_coupon: response.coupon
      });
    } else {
      this.setState({
        coupon_applied: false,
        coupon_error: response.error_message || 'Invalid Promo Code',
        trial_coupon: null
      });
    }

  }

  async subscriptionSignUp() {
    if (this.state.loading) {
      return;
    }

    this.setState({loading: true}, async () => {
      let cc_info = this.getCCInfo();
      let cc_exp_tokens = cc_info.cc_exp.split('/');

      cc_info = {
        cc_holder_name: cc_info.cc_holder_name,
        cc_num: cc_info.cc_number,
        cc_exp_month: cc_exp_tokens[0],
        cc_exp_year: cc_exp_tokens[1],
        cc_cvc: cc_info.cc_cvc,
        billing_zipcode: cc_info.cc_zipcode,
        partner_id: this.props.partner_id,
        period: this.props.period,
      }

      console.log('cc_info', cc_info);

      if(ArrayUtils.allKeysNotNull(cc_info)) {

        if (this.state.trial_coupon && this.state.trial_coupon.promo_code) {
          cc_info['coupon'] = this.state.trial_coupon.promo_code;
        }

        let response = await AuthController.createSubscription(cc_info);

        if(response.success) {
          this.props.continue_btn_action(cc_info) ;
        } else {
          this.setState({
            loading: false,
            subscription_error: response.error
          })
        }
      } else {
        this.setState({
          loading: false,
          subscription_error: "All fields are required."
        })
      }
    });
  }

  getCCInfo() {
    let cc_zipcode = this.state.cc_zipcode,
    cc_exp = this.state.cc_exp,
    cc_number = this.state.cc_number,
    cc_holder_name = this.state.cc_holder_name;

    let cc_info = {
      cc_holder_name,
      cc_number,
      cc_exp,
      cc_cvc: this.state.cc_cvc,
      cc_zipcode
    }

    return cc_info;
  }

  validateForm() {
    let cc_info = this.getCCInfo();

    let valid = ArrayUtils.allKeysNotNull(cc_info);

    if(valid && cc_info.cc_exp) {
      valid = StringUtils.validateExpirationDate(cc_info.cc_exp);
    }

    if(valid && cc_info.cc_zipcode) {
      valid = cc_info.cc_zipcode.length === 5;
    }

    return valid;
  }

  update_field(name, value) {
    this.setState({
      [name]: value
    }, () => {
      this.setState({
        form_valid: this.validateForm()
      })
    });
  }

  update_expiration_field = (expiration_date_str) => {
    let new_string = expiration_date_str;
        new_string = new_string.replace('/', '');

    if (new_string.length === 3) {
      new_string = new_string[0] + new_string[1]  + '/' + new_string[2];
    } else if (new_string.length >= 4) {
      new_string = new_string[0] + new_string[1]  + '/' + new_string[2] + new_string[3];
    }

    this.setState({ cc_exp: new_string })
  }

  render_inputs_section = () => {
    if (!this.state.display_cc_inputs) {
      return null;
    }

    return <View style={{ marginTop: 10 }}>
       <Input label={ 'Card Holder Name' }
              style={{ marginBottom: 10 }}
              onChangeText={ (cc_holder_name) => { this.update_field('cc_holder_name', cc_holder_name)}} />

       <Input label={ 'Credit Card Number' }
              style={{ marginBottom: 10 }}
              keyboardType='number-pad'
              onChangeText={ (cc_number) => { this.update_field('cc_number', cc_number)}} />

       <Input label={ 'Expiration MM/YY' }
              style={{ marginBottom: 10 }}
              value={this.state.cc_exp}
              placeholder='MM/YY'
              onChangeText={ (cc_exp) => { this.update_expiration_field(cc_exp) }} />

        <Input label={ 'CVV' }
               style={{ marginBottom: 10 }}
               keyboardType='number-pad'
               onChangeText={ (cc_cvc) => { this.update_field('cc_cvc', cc_cvc)}} />

        <Input label={ 'Zipcode' }
               style={{ marginBottom: 10 }}
               keyboardType='number-pad'
               onChangeText={ (cc_zipcode) => { this.update_field('cc_zipcode', cc_zipcode)}} />
    </View>
  }

  render_payment_button = () => {
    if (!this.state.display_cc_inputs) {
      return null;
    }

    let valid              = this.state.form_valid;
    let loading            = this.state.loading;
    let subscription_error = this.state.subscription_error;

    return <View style={{ alignItems: 'center' }}>
      {subscription_error ? <Text style={styles.error_message}>{subscription_error}</Text> : null}
      <Button title='Subscribe'
              inactive={!valid}
              loading={loading}
              style={{ width: 335, marginTop: 15, height: 50, borderRadius: 5 }}
              onPress={this.subscriptionSignUp}/>
    </View>
  }

  render_credit_card_toggle = () => {
    if (this.state.display_cc_inputs) {
      return null;
    }

    return <View style={{ alignItems: 'center' }}>
      <Button title='Subscribe with Credit Card'
              style={{ width: 335, marginTop: 12, borderRadius: 5, height: 50 }}
              onPress={ () => {
                this.setState({ display_cc_inputs: true })
              }}/>
    </View>

  }

  render_promo_section = () => {
    if (this.props.period !== 'month') {
      return <View style={{ height: 15 }}></View>;
    }

    let display_message = this.state.trial_coupon && this.state.trial_coupon.display_message ? this.state.trial_coupon.display_message : '';
    let coupon_applied  = this.state.coupon_applied      === true ? true : false;
    let display_input   = this.state.display_promo_input === true ? true : false;

    if (display_input && !coupon_applied) {
      return <View style={{ marginTop: 20, marginBottom: 20 }}>
        <View style={{ flexDirection: 'row' }}>
          <Input placeholder="Promo Code"
                 style={{ height: 55, borderRadius: 5, flex: 1, width: 235 }}
                 value={this.state.coupon}
                 onChangeText={ (coupon) => {
                   let upper_case_coupon = coupon.toUpperCase();
                   this.setState({ coupon: upper_case_coupon })}}
                  />
          <Button title="Apply" style={{ borderRadius: 5, height: 55, width: 110, marginLeft: 5 }} onPress={this.verifyCoupon} />
        </View>
        { this.state.coupon_error ? <Text style={{ marginTop: 10, fontSize: 15, color: Colors.RED }}>{ this.state.coupon_error }</Text> : null}
      </View>
    }

    if (!display_input && !coupon_applied) {
      return <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', marginTop: 20, marginBottom: 22 }}
                               onPress={ () => {
                                 this.setState({ display_promo_input: true })
                               }}>
        <Icon name='plus-circle' size={18} solid={true} color={'#cfcfcf'} />
        <Text style={{ color: '#575762', fontSize: 17, marginLeft: 5 }}>{ 'Apply a promo code' }</Text>
      </TouchableOpacity>
    }

    if (coupon_applied) {
      return <View style={{ flexDirection: 'row', marginTop: 15, marginBottom: 15, borderColor: '#e7e7e7', borderWidth: 1, padding: 10, width: 335, borderRadius: 5 }}>
        <View style={{ flexDirection: 'column', flex: 1 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Icon name='check-circle' size={18} solid={true} color={Colors.GREEN} />
            <Text style={{ color: Colors.TEXT_GREY, fontSize: 14, marginLeft: 6, fontWeight: 'bold' }}>Promo Applied</Text>
          </View>
          <Text style={{ color: '#575762', fontSize: 15, marginTop: 5 }}>{ display_message }</Text>
        </View>
        <TouchableOpacity style={{ justifyContent: 'center', alignItems: 'center', width: 40 }}
                          onPress={ () => {
                            this.setState({ coupon_applied: false, display_promo_input: false, trial_coupon: null, coupon: '' })
                          }}>
          <Icon name='times-circle' size={18} solid={true} color={'#cfcfcf'} />
        </TouchableOpacity>
      </View>
    }
  }

  render_summary_section = () => {

    return <View style={{ marginTop: 20 }}>

      <Text style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 10 }}>SUMMARY</Text>

      <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: 335 }}>
        <Text style={{ fontSize: 17, color: '#575762' }}>DodoVet Monthly Subscription</Text>
        <Text style={{ fontSize: 17, color: '#575762' }}>${ this.state.price }</Text>
      </View>

      { this.render_promo_section() }

      { this.state.coupon_applied ? <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: 335 }}>
                                      <Text style={{ fontSize: 17, fontWeight: '500' }}>Total due today</Text>
                                      <Text style={{ fontSize: 17, fontWeight: '500' }}>$0.00</Text>
                                    </View>
                                  : <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: 335 }}>
                                      <Text style={{ fontSize: 17, fontWeight: '500' }}>Total due today</Text>
                                      <Text style={{ fontSize: 17, fontWeight: '500' }}>${ this.state.total_price }</Text>
                                    </View> }

    </View>
  }

  render() {

    if (!this.props.display) {
      return null;
    }

    let coupon_applied  = this.state.coupon_applied      === true ? true : false;

    return (
      <View style={styles.main_container}>
        <View style={{ /*height: 65,*/ width: 330, paddingLeft: 5 }}>
          <Text style={{ fontSize: 32, fontWeight: 'bold' }}>Payment Info</Text>
          <Text style={{ fontSize: 16, color: '#575762' }}>One last step before we get started.</Text>

          { this.render_summary_section() }

        </View>
        <Line style={{ marginTop: 20 }}/>
        { this.render_credit_card_toggle() }
        { this.render_inputs_section()     }
        { this.render_payment_button()     }
        <Line style={{ marginTop: 12, marginBottom: 12 }}/>

        <ApplePay coupon={this.state.coupon_applied && this.state.trial_coupon ? this.state.trial_coupon : null} price={this.props.price} period={this.props.period} onSubscriptionCompleted={()=>{this.props.continue_btn_action()}} />
      </View>
    );
  }
}

function SignUpPaymentInput(props) {
  if(Platform.OS === 'web') {
    let navigate = useNavigate();

    return  <SignUpPaymentInput_Base {...props} navigate={navigate} />
  } else {
    return  <SignUpPaymentInput_Base {...props} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({
  content_container: {
    backgroundColor: 'white',
    borderRadius: 15,
    borderWidth: 1,
    borderColor: '#e7e7e7',
    padding: 20,
  },
  main_container: {
    flex: 1,
    padding: 20,
    paddingTop: 5
  },
  error_message: {
    color: 'red'
  }
});

export default SignUpPaymentInput
